import React from 'react';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { setDataLayer } from 'shared/actions/globals';
import { connect } from 'react-redux';

import SuggestModal from '../SuggestModal/SuggestModal';
import CommonLeasingButton from '../../LeasingOnlineBanner/CommonLeasingButton/CommonLeasingButton';

// eslint-disable-next-line css-modules/no-unused-class
import s from './SuggestButton.css';

class SuggestButton extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    children: PropTypes.node,
    showModal: PropTypes.bool,
    toggleModal: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    leasingParams: null,
    currencySlug: 'uah',
    children: null,
    showModal: false,
  };

  render() {
    const { advert, children, showModal, toggleModal, t } = this.props;
    const title = t('Подобрать');
    return (
      <React.Fragment>
        <CommonLeasingButton onClick={toggleModal} className="leasing" title={title}>
          {children}
        </CommonLeasingButton>
        <SuggestModal toggleModal={toggleModal} show={showModal} advert={advert} />
      </React.Fragment>
    );
  }
}

export default connect(
  null,
  { setDataLayer },
)(withStyles(s)(withTranslate(SuggestButton)));



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestButton/SuggestButton.js